/**
 * "Edit Checklist" trigger rendered inside the Service Plan's "Schedules in
 * this plan" related list. Opens `<ChecklistEditorDialog>` in-place — no
 * page navigation — so the operator stays in the Service Plan context.
 */
import React from 'react';
import { ChecklistEditorDialog } from './checklist-editor-dialog';

export function EditChecklistLink({
  scheduleId, scheduleName, servicePlanId,
}: { scheduleId: string; scheduleName?: string; servicePlanId?: string }) {
  const [open, setOpen] = React.useState(false);
  const onClick = (e: React.MouseEvent) => {
    // Don't bubble — surrounding row may have a click handler we'd trigger.
    e.stopPropagation();
    e.preventDefault();
    setOpen(true);
  };
  return (
    <>
      <button
        type="button"
        onClick={onClick}
        className="text-primary hover:underline text-xs whitespace-nowrap"
      >
        Edit
      </button>
      {open && (
        <ChecklistEditorDialog
          open={open}
          onClose={() => setOpen(false)}
          scheduleId={scheduleId}
          scheduleName={scheduleName}
          servicePlanId={servicePlanId}
        />
      )}
    </>
  );
}
